import type { NoiseReducer, NoiseReductionProvider } from "./NoiseReducer";

/**
 * No-op reducer: passes the MediaStream through unchanged.
 * Used when the user explicitly disables all noise processing.
 */
export class PassThroughReducer implements NoiseReducer {
    async init(): Promise<void> {
        // No initialization required.
    }

    async processStream(input: MediaStream): Promise<MediaStream> {
        return input;
    }

    close(): void {
        // Nothing to release.
    }

    getProvider(): NoiseReductionProvider {
        return "passthrough";
    }
}
